import { getToken } from '@/utils/token.js'
import { useUserStore } from '@/stores/user'

// 路由白名单：不需要登录就可以访问的页面
const whiteList = [
  '/login', //登录

  '/404'
]
import router from './index.js'

// 路由导航守卫
router.beforeEach(async (to, from, next) => {
  // 如果是404页面，直接允许访问
  if (to.path === '/404') {
    next()
    return
  }

  if (to.path === '/login') {
    next()
    return
  }

  if (!getToken()) {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
    return
  }

  // 有Token情况下
  const userStore = useUserStore()

  // 如果用户信息不存在，先恢复或获取用户信息
  if (!userStore.userInfo) {
    userStore.restoreUserInfo()
    // 如果恢复后仍然没有用户信息，重新获取
    if (!userStore.userInfo) {
      try {
        await userStore.getUserInfo()
      } catch (error) {
        console.error('获取用户信息失败:', error)
        // 如果获取用户信息失败，跳转到登录页
        next('/login')
        return
      }
    }
  }
  next()
})

// 路由后置守卫
router.afterEach(() => {
  // 可以在这里处理一些路由跳转后的逻辑，比如页面统计等
})
